module.exports = __webpack_public_path__ + "static/media/footer__ig.e49d4ef9.svg";